
import React from 'react';



interface ITableLoadingSkelton {
    columnsNumber: number;
}

/**
 * 
 * @returns 
 */
const TableLoadingSkeleton = ({ columnsNumber = 1 }: ITableLoadingSkelton) => {



    const skeletonRows = Array.from({ length: 5 }, (_, index) => (
        <tr key={index}>
            {Array.from({ length: columnsNumber }, (_, index) => (
                <td style={{
                    "height":"5rem",
                    "padding": "8px",
                    "textAlign": "center"}}>
                         <div className='mt-4 animate-pulse flex items-center justify-between'>
                          <div className="h-3.5 bg-gray-300 rounded-full dark:bg-gray-600 w-full mb-2.5"></div>
                         </div>
                  </td>

            ))}

        </tr>
    ));

    return (
        <tbody>
            {skeletonRows}
        </tbody>
    );
};

export default TableLoadingSkeleton;
